import { Button } from '@/components/ui/button';
import { ComponentPropsWithoutRef, ReactNode } from 'react';

interface PrimaryButtonProps extends ComponentPropsWithoutRef<typeof Button> {
    children: ReactNode;
    className?: string;
}

export function SubtleButton({ children, className, ...props }: PrimaryButtonProps) {
    return (
        <Button
            className={`
              bg-tertiary-blue-50 h-auto font-medium shadow-[0px_1px_2px_0px_#1018280D] text-[#555f62] text-xs leading-[22.5px] rounded-lg px-3 py-2 border border-white-blue-500
              hover:bg-white-blue-500 hover:border-[#E1DEE0]
              focus:outline-none focus:ring-2 focus:ring-white-blue-500 focus:ring-offset-2
              disabled:bg-white-blue-50 disabled:opacity-50 disabled:border-white-blue-300
        ${className || ''}
      `}
            {...props}
        >
            {children}
        </Button>
    );
}
